import React from "react";
import { Link } from "react-router-dom";

function Ourteem() {
  const data = [
    {
      id: 1,
      img: "assets/images/team/team-1-1.jpg",
      name: "Brian S. Brooks",
      subname: "CEO & Founder",
    },
    {
      id: 2,
      img: "assets/images/team/team-1-2.jpg",
      name: "Ricky W. Montez",
      subname: "Senior Manager",
    },
    {
      id: 3,
      img: "assets/images/team/team-1-3.jpg",
      name: "William D. Damian",
      subname: "Business Consultant",
    },
    {
      id: 4,
      img: "assets/images/team/team-1-4.jpg",
      name: "Karl D. Boudreau",
      subname: "Marketing Officer",
    },
    {
      id: 5,
      img: "assets/images/team/team-1-5.jpg",
      name: "William J. Monroe",
      subname: "Consultant",
    },
    {
      id: 6,
      img: "assets/images/team/team-1-6.jpg",
      name: "Robert M. Chacon",
      subname: "Junior Marketer",
    },
    {
      id: 7,
      img: "assets/images/team/team-1-7.jpg",
      name: "Ronald J. Glasser",
      subname: "Sr. Developer",
    },
    {
      id: 8,
      img: "assets/images/team/team-1-8.jpg",
      name: "Myron C. Penland",
      subname: "UI Designer",
    },
    {
      id: 9,
      img: "assets/images/team/team-1-9.jpg",
      name: "Lloyd L. Bowman",
      subname: "SEO Marketer",
    },
    {
      id: 10,
      img: "assets/images/team/team-1-10.jpg",
      name: "Ronnie V. Warren",
      subname: "Junior Marketer",
    },
    {
      id: 11,
      img: "assets/images/team/team-1-10.jpg",
      name: "Ronnie V. Warren",
      subname: "SEO Marketer",
    },
    {
      id: 12,
      img: "assets/images/team/team-1-10.jpg",
      name: "Ronnie V. Warren",
      subname: "Junior Marketer",
    },
  ];
  return (
    <>
      <section className="team-one">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">meet our team</p>

            <h3 className="sec-title__title">
              We’ve professional team member <br />
              meet with our agent
            </h3>
          </div>

          <div className="row">
            {data.map((item) => (
              <div className="col-md-6 col-lg-4 col-xl-3" key={item.id}>
                <div className="team-card">
                  <div className="team-card__image">
                    <img src={item.img} />
                    <div className="team-card__hover">
                      <h3 className="team-card__title">
                        <Link to="/teamdetails">{item.name}</Link>
                      </h3>

                      <p className="team-card__designation">{item.subname}</p>

                      <ul className="list-unstyled team-card__social">
                        <li>
                          <a to="https://www.facebook.com/">
                            <i className="fab fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a to="https://twitter.com/">
                            <i className="fab fa-twitter" />
                          </a>
                        </li>
                        <li>
                          <a to="/https://www.linkedin.com/">
                            <i className="fab fa-linkedin-in" />
                          </a>
                        </li>
                        <li>
                          <a to="https://www.instagram.com/">
                            <i className="fab fa-instagram" />
                          </a>
                        </li>
                      </ul>

                      <Link
                        to="/teamdetails"
                        className="team-card__hover__link"
                      >
                        <i className="far fa-arrow-right" />
                      </Link>
                    </div>
                  </div>

                  <div className="team-card__content">
                    <h3 className="team-card__title">
                      <Link to="/teamdetails">{item.name}</Link>
                    </h3>

                    <p className="team-card__designation">{item.subname}</p>

                    <Link
                      to="/teamdetails"
                      className="team-card__content__link"
                    >
                      <i className="far fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Ourteem;
